var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"图片查看","draggable":"","footer-hide":""},model:{value:(_vm.modalVisible),callback:function ($$v) {_vm.modalVisible=$$v},expression:"modalVisible"}},[_c('img',{staticClass:"image-modal-main-container",attrs:{"src":_vm.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }